import { Paragraph } from "components/atoms/Typography";
import "./ChartLegend.css";

interface ChartLegendProps {
    keys: {
        color: string;
        label: string;
        isHidden?: boolean;
    }[];
    onItemClick?: (label: string) => void;
}

function ChartLegend({ keys, onItemClick }: ChartLegendProps) {
    return (
        <div className="chart-legend">
            {keys.map(({ color, label, isHidden }) => (
                <div
                    key={`${color}$${label}`}
                    className="chart-legend__key"
                    onClick={() => onItemClick?.(label)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onItemClick?.(label);
                        }
                    }}
                    role="button"
                    tabIndex={onItemClick ? 0 : undefined}
                    aria-pressed={isHidden}
                    style={{
                        cursor: onItemClick ? "pointer" : "default",
                        opacity: isHidden ? 0.5 : 1,
                    }}
                >
                    <div
                        className="chart-legend__color"
                        style={{
                            backgroundColor: color,
                        }}
                    />
                    <Paragraph
                        style={{
                            color: "var(--audette-gray-600)",
                        }}
                        key={color}
                    >
                        {label}
                    </Paragraph>
                </div>
            ))}
        </div>
    );
}

export default ChartLegend;
